import React from 'react';
import { Flower2Icon, LeafIcon } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <main className="w-full max-w-3xl mx-auto p-4 min-h-[calc(100vh-64px)] relative" data-id="element-32">
      {/* Decorative background elements */}
      <div className="fixed top-20 left-4 text-green-100 opacity-20 transform -rotate-15 hidden md:block" data-id="element-33">
        <LeafIcon size={160} data-id="element-34" />
      </div>
      <div className="fixed bottom-20 right-4 text-green-100 opacity-20 transform rotate-15 hidden md:block" data-id="element-35">
        <Flower2Icon size={180} data-id="element-36" />
      </div>
      <div className="fixed top-1/3 right-1/4 text-green-100 opacity-10 transform rotate-45 hidden md:block" data-id="element-37">
        <LeafIcon size={120} data-id="element-38" />
      </div>
      <div className="fixed bottom-1/3 left-1/4 text-green-100 opacity-10 transform -rotate-45 hidden md:block" data-id="element-39">
        <Flower2Icon size={140} data-id="element-40" />
      </div>
      {/* Content with relative positioning to appear above background elements */}
      <div className="relative z-10" data-id="element-41">{children}</div>
    </main>;
};
export default Layout;